module.exports = __webpack_public_path__ + "static/sec3-bg-sm-4bcfc581fc9b27735d36c52932b79501.jpg";